import { JsonUtils } from "../../utils/json.util"

export class Alert {
    private _id: string | undefined
    private _followup_id: string | undefined
    private _patient_id: string | undefined
    private _date: string | undefined
    private _contact: string | undefined
    private _county: string | undefined
    private _comment: string | undefined
    private _status: boolean | undefined

    get id(): string | undefined {
        return this._id
    }

    set id(value: string | undefined) {
        this._id = value
    }
    get followup_id(): string | undefined {
        return this._followup_id
    }

    set followup_id(value: string | undefined) {
        this._followup_id = value
    }
    get patient_id(): string | undefined {
        return this._patient_id
    }

    set patient_id(value: string | undefined) {
        this._patient_id = value
    }
    get date(): string | undefined {
        return this._date
    }

    set date(value: string | undefined) {
        this._date = value
    }
    get contact(): string | undefined {
        return this._contact
    }

    set contact(value: string | undefined) {
        this._contact = value
    }
    get county(): string | undefined {
        return this._county
    }

    set county(value: string | undefined) {
        this._county = value
    }
    get comment(): string | undefined {
        return this._comment
    }

    set comment(value: string | undefined) {
        this._comment = value
    }

    get status(): boolean | undefined {
        return this._status
    }

    set status(value: boolean | undefined) {
        this._status = value
    }
    // metodo responsavel por formatar os dados do backend para frontend
    public fromJSON(json: any): Alert {
        if (!json) {
           
            return this
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }
        if (json.id !== undefined) {
            this.id = json.id
        }
        if (json.followup_id !== undefined) {
            this.followup_id = json.followup_id
        }
        if (json.patient_id !== undefined) {
            this.patient_id = json.patient_id
        }
        if (json.date !== undefined) {
            this.date = json.date
        }
        if (json.contact !== undefined) {
            this.contact = json.contact
        }
        if (json.county !== undefined) {
            this.county = json.county
        }
        if (json.comment !== undefined) {
            this.comment = json.comment
        }
        if (json.status !== undefined) {
            this.status = json.status
        }
        return this
    }
    // metodo responsavel para formatar os dados do front para o back
    public toJSON(): any {
        return {
            id: this.id || undefined,
            followup_id: this.followup_id || undefined,
            patient_id: this.patient_id || undefined,
            date: this.date || undefined,
            contact: this.contact || undefined,
            county: this.county || undefined,
            comment: this.comment || undefined,
            status: this.status
        }
    }
}